import * as screenSettingsActions from '../actions/screenSettings.actions';
import { put, retry, takeLatest } from 'redux-saga/effects';
import { createScreenSettings, getScreenSettingsByScreenNameTableName, updateScreenSettings, } from '../services';
function* getUserPreferences(action) {
    const { screenSettingsResolved, screenSettingsRejected } = screenSettingsActions;
    try {
        const { data } = yield retry(5, 1500, getScreenSettingsByScreenNameTableName, action.payload.tableName, action.payload.screenName);
        if (data && data.configs) {
            yield put(screenSettingsResolved(data));
        }
        else {
            yield put(screenSettingsRejected(action.payload));
        }
    }
    catch (e) {
        yield put(screenSettingsRejected(action.payload));
    }
}
function* createUserPreferences(action) {
    const { screenSettingsRejected, screenSettingsResolved } = screenSettingsActions;
    try {
        const { data } = yield retry(5, 1500, createScreenSettings, action.payload);
        if (data && data.configs) {
            yield put(screenSettingsResolved(data));
        }
        else {
            yield put(screenSettingsRejected({
                tableName: action.payload.tableConfigs.tableName,
                screenName: action.payload.tableConfigs.screenName,
                defaultColumns: action.payload.defaultColumns,
            }));
        }
    }
    catch (e) {
        yield put(screenSettingsRejected({
            tableName: action.payload.tableConfigs.tableName,
            screenName: action.payload.tableConfigs.screenName,
            defaultColumns: action.payload.defaultColumns,
        }));
    }
}
function* updateUserPreferences(action) {
    const { screenSettingsRejected, screenSettingsResolved } = screenSettingsActions;
    const { tableConfigs, defaultColumns } = action.payload;
    try {
        const { data } = yield retry(5, 1500, updateScreenSettings, action.payload);
        if (data && data.configs) {
            yield put(screenSettingsResolved(data));
        }
        else {
            yield put(screenSettingsRejected({
                tableName: tableConfigs.tableName,
                screenName: tableConfigs.screenName,
                defaultColumns,
            }));
        }
    }
    catch (e) {
        yield put(screenSettingsRejected({
            tableName: tableConfigs.tableName,
            screenName: tableConfigs.screenName,
            defaultColumns,
        }));
    }
}
function* watchGetUserPreferences() {
    yield takeLatest(screenSettingsActions.getScreenSettingsByScreenNameTableName, getUserPreferences);
}
function* watchCreateUserPreferences() {
    yield takeLatest(screenSettingsActions.createScreenSettings, createUserPreferences);
}
function* watchUpdateUserPreferences() {
    yield takeLatest(screenSettingsActions.updateScreenSettings, updateUserPreferences);
}
export default [
    watchGetUserPreferences(),
    watchCreateUserPreferences(),
    watchUpdateUserPreferences(),
];
